import React from "react";

import GoldButton from "./GoldButton";
import GoldBorderImage from "../assets/gold_double_square.svg";

const CTA = ({ title, content, link }) => {
	return <>
		<section className="CTA">
			<div className="container">
				<p className="section-title">{title ? title : "Have a project like this one?"}</p>
				{content ? content.map((text, key) => <p key={key}>{text}</p>) : <p>I work with all kinds of projects and can help yours get to the finish line.</p>}
				<div className="gold-bordered">
					<GoldButton text="Let's talk about it" link="/contact" />
					<img src={GoldBorderImage} alt="" width="500" height="500" />
				</div>
			</div>
		</section>
	</>
}

export default CTA;